import axios from "axios";
import { Base_URL } from "../url";

export const fetchStores = async () => {
  try {
    const response = await axios.get(`${Base_URL}/StoreMaster/GetAllStores`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching stores!";
  }
};

export const downloadStoresExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/StoreMaster/DownloadStoresExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading stores data!";
  }
};